<div class="availability-header" id="calendar-header">
  <h1 class="availability-header-label">{{ periodLabel | titlecase }}</h1>
  <span>
    <app-icon-button
      (action)="previousClicked($event)"
      icon="arrow_left"
      class="calendar-header-previous-button"
      buttonId="calendar-header-previous-button"
      [disabled]="prevButtonDisabled()"
      [label]="'Select previous month'"
      [isOutline]="true"></app-icon-button>
    <app-icon-button
      (action)="nextClicked($event)"
      icon="arrow_right"
      [label]="'Select next month'"
      [disabled]="nextButtonDisabled()"
      buttonId="calendar-header-next-button"
      [isOutline]="true">
    </app-icon-button>
    <app-icon-button
      [isOutline]="false"
      class="mobile-only-close-button"
      label="Close calendar"
      icon="close"
      *ngIf="!isMobile"
      [isCdkFocusInitial]="true"
      buttonId="calendar-header-close-button"
      backgroundColor="var(--roller-neutral-95)"
      (action)="closeDialog()">
    </app-icon-button>
  </span>
</div>
